module.exports = __webpack_public_path__ + "static/media/conference-partners.1e5dc323.png";